// route-progress.service.ts
import { Injectable, Signal, signal, inject } from '@angular/core';
import { Router, Event as RouterEvent, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class RouteProgressService {
    private router = inject(Router);

    private readonly MIN_VISIBLE = 800;
    private pending = 0;

    private _loading = signal(false);
    get loading(): Signal<boolean> { return this._loading; }

    private shownAt = 0;
    private hideTimer: any = null;

    constructor() {
        this.router.events.subscribe(e => this.onRouterEvent(e));
    }

    private onRouterEvent(e: RouterEvent) {
        if (e instanceof NavigationStart) {
            this.inc();
        } else if (e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError) {
            this.dec();
        }
    }

    private inc() {
        this.pending++;
        if (this.pending === 1) {
            if (this.hideTimer) { clearTimeout(this.hideTimer); this.hideTimer = null; }
            if (!this._loading()) {
                this._loading.set(true);
                this.shownAt = Date.now();
            }
        }
    }

    private dec() {
        if (this.pending > 0) this.pending--;
        if (this.pending === 0) {
            const elapsed = Date.now() - this.shownAt;
            const wait = Math.max(0, this.MIN_VISIBLE - elapsed);

            if (this.hideTimer) clearTimeout(this.hideTimer);
            this.hideTimer = setTimeout(() => {
                this._loading.set(false);
                this.hideTimer = null;
            }, wait);
        }
    }
}
